import React, { useEffect, useMemo, useState, createContext, useContext } from 'react';
import { Locale } from '../types/content';
export type { Locale };
type LocaleContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};
const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);
export function LocaleProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [locale, setLocale] = useState<Locale>(() => {
    return localStorage.getItem('brugge-locale') === 'en' ? 'en' : 'nl';
  });
  useEffect(() => {
    document.documentElement.lang = locale;
    localStorage.setItem('brugge-locale', locale);
  }, [locale]);
  const value = useMemo(() => ({
    locale,
    setLocale
  }), [locale]);
  return <LocaleContext.Provider value={value} data-id="element-19" data-mp="3b7tfjx52uhnr">{children}</LocaleContext.Provider>;
}
export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return context;
}